import React from 'react';
import { Txt } from '@vst/beam';

type SubscriptionCardProps = {
  name: string;
  icon: React.ReactNode;
};

const SubscriptionCard = ({ name, icon }: SubscriptionCardProps) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
      {icon}
      <Txt variant="bodySmallBold">{name}</Txt>
    </div>
  );
};

export default SubscriptionCard;
